import styled from "styled-components";

export const Title = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #101820;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 4px;
`;

export const Desc = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #727C8A;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const Items = styled.div`
  flex-direction: row;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  max-width: 100%;
  width: 100%;

  & > div:nth-child(2n) {
    margin-right: 0;
  }
`;
export const Item = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 170px;
  border: 1px solid #DDDDDD;
  border-radius: 8px;
  width: calc(50% - 10px);
  margin-right: 20px;
  margin-top: 20px;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  transition: all 0.2s;

  &.list {
    padding: 16px;
    width: 100%;
    margin-right: 0;
    display: flex;
    flex-direction: row;
    height: 118px;
    align-items: flex-start;
    padding-right: 32px;

    & * {
      text-align: left;
    }

    & svg {
      top: 37px;
    }
  }

  &.active {
    background: rgba(64, 166, 140, 0.1);
    border: 1px solid #40A68C;
  }

  & > svg {
    position: absolute;
    z-index: 1;
    right: 12px;
    top: 12px;
  }
`;
export const ItemImage = styled.div`
  width: 100%;
  height: 120px;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 12px;
  flex: none;

  &.list {
    margin-bottom: 0;
    width: 56px;
    height: 56px;
    border-radius: 56px;
  }

  & img {
    width: 100%;
    height: 120px;
    object-fit: cover;
  }

  &.list img {
    width: 56px;
    height: 56px;
  }
`;

export const ItemInfo = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  overflow: hidden;
  padding: 0 16px 16px;

  &.list {
    padding: 0;
    border-left: 1px solid #DDDDDD;
    margin-left: 12px;
    padding-left: 12px;

    & > div {
      -webkit-line-clamp: 3; /* number of lines to show */
      line-clamp: 4;
    }
  }
`;

export const ItemTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #494949;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: center;
  width: 100%;
`;
export const ItemDesc = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #727C8A;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  line-clamp: 3;
  -webkit-box-orient: vertical;
  width: 100%;
  white-space: pre-wrap;
`;

export const ListIcon = (props: any) => (
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M8 17C8 16.4477 8.44772 16 9 16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H9C8.44772 18 8 17.5523 8 17Z"
              fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M4 17C4 16.4477 4.44772 16 5 16H5.002C5.55428 16 6.002 16.4477 6.002 17V17.002C6.002 17.5543 5.55428 18.002 5.002 18.002H5C4.44772 18.002 4 17.5543 4 17.002V17Z"
              fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M8 12C8 11.4477 8.44772 11 9 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H9C8.44772 13 8 12.5523 8 12Z"
              fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M4 12C4 11.4477 4.44772 11 5 11H5.002C5.55428 11 6.002 11.4477 6.002 12V12.002C6.002 12.5543 5.55428 13.002 5.002 13.002H5C4.44772 13.002 4 12.5543 4 12.002V12Z"
              fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M8 7C8 6.44772 8.44772 6 9 6H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H9C8.44772 8 8 7.55228 8 7Z"
              fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M4 7C4 6.44772 4.44772 6 5 6H5.002C5.55428 6 6.002 6.44772 6.002 7V7.002C6.002 7.55428 5.55428 8.002 5.002 8.002H5C4.44772 8.002 4 7.55428 4 7.002V7Z"
              fill="white"/>
    </svg>
)
export const CheckedIcon = (props: any) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.00004 1.33203C4.32671 1.33203 1.33337 4.32536 1.33337 7.9987C1.33337 11.672 4.32671 14.6654 8.00004 14.6654C11.6734 14.6654 14.6667 11.672 14.6667 7.9987C14.6667 4.32536 11.6734 1.33203 8.00004 1.33203ZM11.1867 6.46536L7.40671 10.2454C7.31337 10.3387 7.18671 10.392 7.05337 10.392C6.92004 10.392 6.79337 10.3387 6.70004 10.2454L4.81337 8.3587C4.62004 8.16536 4.62004 7.84536 4.81337 7.65203C5.00671 7.4587 5.32671 7.4587 5.52004 7.65203L7.05337 9.18536L10.48 5.7587C10.6734 5.56536 10.9934 5.56536 11.1867 5.7587C11.38 5.95203 11.38 6.26536 11.1867 6.46536Z"
            fill="#1D896D"/>
    </svg>

)